import React from "react";

const Logo = ({ className = "" }) => {
  return (
    <img
      src="/images/banque-photo/img-41.png"        // le fichier est bien dans public/images
      alt="Accueil"
      className={`logo-svg ${className}`}
      loading="eager"
      decoding="async"
    />
  );
};

export default Logo;
